export const TAB_VALIDATIONS = {
  ASSET_MODEL: 'assetModel',
  ASSET_TYPES: 'assetType',
  ASSET_VALIDATIONS: 'assetValidation',
  ROOM_ISSUES: 'roomIssues'
  // TRIGGER_TYPES: 'triggerTypes'
} as const;
export const headerTabValidations = [
  { label: 'Asset Validation', param: TAB_VALIDATIONS.ASSET_VALIDATIONS, value: 0 },
  { label: 'Asset Types', param: TAB_VALIDATIONS.ASSET_TYPES, value: 1 },
  { label: 'Asset Model', param: TAB_VALIDATIONS.ASSET_MODEL, value: 2 },
  { label: 'Location Issues', param: TAB_VALIDATIONS.ROOM_ISSUES, value: 3 }
  // { label: 'Trigger Types', param: TAB_VALIDATIONS.TRIGGER_TYPES, value: 4 }
];

export const HEADER_ASSET_MODAL_TAB = [
  { label: 'Model Name', sort: 'name' },
  { label: 'Manufacturer', sort: 'manufacturer.name' },
  { label: 'Type', sort: 'type.name' },
  { label: 'PDFs' },
  { label: 'Actions', width: 120 }
];

export const HEADER_ASSET_TYPES_TAB = [
  { label: 'Asset Type', sort: 'name' },
  { label: 'Entry Fields' },
  { label: 'Creation Date', sort: 'createdAt' },
  { label: 'Actions', width: 120 }
];

export const HEADER_TRIGGER_TYPES_TAB = [
  { label: 'Trigger Type' },
  { label: 'Actions', width: 100 }
];

export const OPTION_CATEGORY = [
  {
    value: 'Electrical_Properties',
    label: 'Electrical Properties'
  },
  {
    value: 'Physical_Dimensions',
    label: 'Physical Dimensions'
  },
  {
    value: 'Installation_Details',
    label: 'Installation Details'
  },
  {
    value: 'Oil_and_Coolant_Properties',
    label: 'Oil and Coolant Properties'
  },
  {
    value: 'Manufacturers_and_Properties',
    label: 'Manufacturers and Properties'
  },
  {
    value: 'Protection_and_Connection',
    label: 'Protection and Connection'
  },
  {
    value: 'Performance_and_Load',
    label: 'Performance and Load'
  },
  {
    value: 'Miscellaneous',
    label: 'Miscellaneous'
  }
];

export const OPTION_UNIT = [
  { value: '10%', label: '10%' },
  { value: '20%', label: '20%' },
  { value: '30%', label: '30%' },
  { value: '40%', label: '40%' },
  { value: '50%', label: '50%' },
  { value: '60%', label: '60%' },
  { value: '70%', label: '70%' },
  { value: '80%', label: '80%' },
  { value: '90%', label: '90%' },
  { value: '100%', label: '100%' }
];

export const HEADER_ASSET_VALIDATION_TAB = [
  { label: 'Asset Name', sort: 'name', width: 150 },
  { label: 'Client Name', sort: 'submitted.room.client.clientName', width: 150 },
  { label: 'Main Location', sort: 'submitted.room.parent.parent.parent.parent.name', width: 150 },
  { label: 'Sub Location 1', sort: 'submitted.room.parent.parent.parent.name', width: 150 },
  { label: 'Sub Location 2', sort: 'submitted.room.parent.parent.name', width: 150 },
  { label: 'Vertical Level', sort: 'submitted.room.parent.name', width: 150 },
  { label: 'Location', sort: 'submitted.room.name', width: 150 },
  { label: 'Asset Type', sort: 'type.name', width: 200 },
  { label: 'Issue', width: 100 },
  { label: 'Model', sort: 'model.name', width: 150 },
  { label: 'Validated', sort: 'validated', width: 100 },
  { label: 'Attributes', width: 150 },
  { label: 'Date Created', width: 150 },
  { label: 'Last Modified', width: 150 },
  { label: 'Photo', width: 150 },
  { label: 'Actions', width: 150 }
];
export const headerTabOptions = [
  { label: 'Dropdown', value: 0 },
  { label: 'Single Entry Field', value: 1 }
  // { label: 'Issues Config', value: 2 }
];
